(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["freedom-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('freedom-purchase')){
customElements.define('freedom-purchase',class extends HTMLElement{
connectedCallback(){
 if(this.initialized)return;this.initialized=true;
 const track=this.querySelector('.fc-slides'),slides=[...this.querySelectorAll('.fc-slide')],thumbs=[...this.querySelectorAll('[data-photo]')];
 const go=i=>track.scrollTo({left:Math.max(0,Math.min(slides.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 thumbs.forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.photo))));
 this.querySelector('[data-prev]').addEventListener('click',()=>go(Math.round(track.scrollLeft/track.clientWidth)-1));
 this.querySelector('[data-next]').addEventListener('click',()=>go(Math.round(track.scrollLeft/track.clientWidth)+1));
 track.addEventListener('scroll',()=>{const i=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));this.querySelector('[data-counter]').textContent=(i+1)+' / '+slides.length;},{passive:true});
 const form=this.querySelector('.fc-buy-form'),button=this.querySelector('[data-add]');

 const quantity=form.querySelector('input[name="quantity"]');
 const syncQuantity=()=>{
   const selected=form.querySelector('input[name="id"]:checked');
   if(!selected){quantity.max='5';quantity.value=String(Math.min(5,Math.max(1,parseInt(quantity.value)||1)));return false;}
   const remaining=Math.max(0,Number(selected.dataset.stockLimit)-Number(selected.dataset.cartCount));
   const available=selected.dataset.available==='true'&&remaining>0;
   quantity.max=String(remaining);
   quantity.min=available?'1':'0';
   quantity.disabled=!available;
   quantity.value=String(available?Math.min(remaining,Math.max(1,parseInt(quantity.value)||1)):0);
   button.disabled=!available;
   button.textContent=available?button.dataset.label:button.dataset.sold;
   this.querySelector('[data-stock]').hidden=available;
   this.querySelector('[data-price]').textContent=selected.dataset.price;
   return available;
 };
 quantity.addEventListener('input',syncQuantity);
 form.addEventListener('change',syncQuantity);
 form.addEventListener('submit',e=>{if(!syncQuantity())e.preventDefault();});
 syncQuantity();

}
});
}
  } catch(e) { console.error(e); }
})();

})();
